import React, { Fragment } from 'react';
import { Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import logo from '../assets/images/handy_logo.svg';
import { PATH, HVAC_MONITORING } from '../utils/const.js.erb';


const useStyles = makeStyles(() => ({
  logo: {
    height: '100%',
  }
}));

const getLogoImg = className => {
  const classes = useStyles();

  return (
    <img className={`${classes.logo} ${className ? className : ''}`} src={logo} alt="Handy Logo" width={75} />
  )
}

const getLinkHref = partnerOrderId => (
  partnerOrderId == null
    ? `${window.location.origin}${PATH}`
    : `${window.location.origin}${PATH}/${HVAC_MONITORING}/${partnerOrderId}`
)

const Logo = ({ partnerOrderId, className }) => (
  <Fragment>
    <Link href={ getLinkHref(partnerOrderId) }>
      { getLogoImg(className)}
    </Link>
  </Fragment>
);

export default Logo;
